export const AVERAGE_KEY = "average";
export const CHART_CONTENT = "chart_content";
export const CHART_PERCENT_KEY = "chart_percent";
export const CHART_STYLE_KEY = "chart_style";
export const COLUMN_ORDER_KEY = "column_order";
export const COLUMN_WIDTH_KEY = "column_width";
export const COUNT_KEY = "count";
export const DRAWER_OPEN = "drawerOpen";
export const ESTIMATED_KEY = "estiamted";
export const HEADER_KEY = "_header";
export const HIDDEN_ROWS = "hidden_result_rows";
export const HIDDEN_ROWS_IS_ALL = "hidden_rows_is_all";
export const IN_PROGRESS_SEARCH = "inProgressSearch";
export const JUDGES_KEY = "_judges";
export const LIBRARY_NAME = "library_name";
export const MAX_KEY = "max";
export const MIN_KEY = "min";
export const NUMBERS_KEY = "numbers";
export const PROFILE_ID = "profile_id";
export const PROFILE_TYPE = "profile_type";
export const Q0_KEY = "q0";
export const Q1_KEY = "q1";
export const Q2_KEY = "q2";
export const Q3_KEY = "q3";
export const Q4_KEY = "q4";
export const REQUIRED_CRITERION = "required_criterion";
export const RESULTS_SELECT_HIDDEN = "results_select_hidden";
export const SORT_ORDER_KEY = "sort_order";
export const TABLE_PERCENT_KEY = "table_percent";
export const TABLEAU_FILTERS = "tableau_filters";
export const TABLEAU_PARAMETERS = "tableau_parameters";
export const TILES_CONTENT = "tiles_content";
